import { authStorage } from '../storages';
import { isAccessTokenExpires, isAccessTokenValid } from '../helpers';
import { checkSso, refreshAuthToken } from '../api';
import { type ISamoletConfiguration } from '../types';
import { goToAuth } from './GoToAuth';

export async function runRefreshProcess(config: ISamoletConfiguration) {
  try {
    const authParams = authStorage.getJwtAuthParams();

    try {
      // Проверка на случай, если рефреш был произведен в параллельной сессии
      if (
        authParams?.access &&
        isAccessTokenValid(authParams.access) &&
        !isAccessTokenExpires(authParams.access)
      ) {
        return;
      }
    } catch {} // eslint-disable-line no-empty

    if (authParams?.refresh) {
      const { access_token, refresh_token } = await refreshAuthToken(
        config,
        authParams.refresh,
      );

      await authStorage.setJwtAuthParams({
        access: access_token,
        refresh: refresh_token,
      });

      if (access_token && refresh_token) {
        return;
      }
    }

    if (config.allowAnonymous && !(await checkSso(config))) {
      return Promise.reject();
    }
  } catch {} // eslint-disable-line no-empty

  await goToAuth(config);
}
